/** Display only. The stored payment method wins over stale manual monthly text. */
export const isCashPayment = (payment: unknown): boolean => {
  if (typeof payment === 'string') {
    try {
      return isCashPayment(JSON.parse(payment))
    } catch {
      return false
    }
  }
  return (
    !!payment &&
    typeof payment === 'object' &&
    'paymentMethod' in payment &&
    payment.paymentMethod === 'cash'
  )
}

/**
 * Editor-only warning (13386542071): the method is Cash, yet a lender, a term
 * or a typed monthly is filled in, so the rep most likely meant Financing and
 * the report is hiding the Monthly Payment because of it.
 */
export const cashHidesFinancing = (
  payment: unknown,
  typedMonthly: unknown,
): boolean => {
  if (!isCashPayment(payment)) return false
  let p: unknown = payment
  if (typeof p === 'string') {
    try {
      p = JSON.parse(p)
    } catch {
      p = null
    }
  }
  const o = (p && typeof p === 'object' ? p : {}) as Record<string, unknown>
  const lender =
    typeof o['loanCompanyName'] === 'string' && !!o['loanCompanyName'].trim()
  const term = typeof o['termYears'] === 'number' && o['termYears'] > 0
  const typed = parseFloat(String(typedMonthly ?? '').replace(/[^0-9.]/g, ''))
  return lender || term || (Number.isFinite(typed) && typed > 0)
}
